import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";

const container = document.getElementById("root");
const element = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, element);
} else {
  createRoot(container).render(element);
}
